import { signInWithRedirect } from 'aws-amplify/auth';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Form } from '@/shared/components/ui/form/form';
import { TSubmittedData } from '@/shared/components/ui/form/form.types';
import { TLoginWithSsoInputSchema } from '@/shared/features/auth/components/login/login.types';
import { loginWithSsoInputSchema } from '@/shared/features/auth/components/login/login.validation';
import { LoginWithSsoForm } from '@/shared/features/auth/components/login-with-sso/login-with-sso-form';
import { useReadIdentityProviderByEmailMutation } from '@/shared/redux/api/ident-public/ident-public-api';
import { showToastError } from '@/shared/utils/toast';

export const LoginWithSso = () => {
  const { t } = useTranslation();
  const [readIdentityProviderByEmail] =
    useReadIdentityProviderByEmailMutation();

  const handleLoginWithSso = async (
    data: TSubmittedData<TLoginWithSsoInputSchema>,
  ) => {
    const appClientId = import.meta.env.VITE_APP_AWS_USER_POOLS_WEB_CLIENT_ID;
    const email = data.data.email;
    const errorMessage = t('auth:identity_provider_not_found', {
      domain: email.split('@')[1],
    });

    try {
      const response = await readIdentityProviderByEmail({
        email,
        appClientId,
      }).unwrap();

      const identityProviderId =
        response?.readIdentityProviderByEmail.identityProviderId;

      if (!identityProviderId) {
        throw new Error(`No identity provider for ${email}`);
      }

      await signInWithRedirect({ provider: { custom: identityProviderId } });
    } catch (error) {
      showToastError(errorMessage);

      // No field error is set, so without this the Form would reset the input.
      throw error;
    }
  };

  return (
    <Form<TLoginWithSsoInputSchema>
      onSubmit={handleLoginWithSso}
      schema={loginWithSsoInputSchema}
    >
      {() => <LoginWithSsoForm />}
    </Form>
  );
};
